// extracted by mini-css-extract-plugin
export default {"lds-roller":"Styles_lds-roller__AELzX","loading-spinner":"Styles_loading-spinner__2MKOY"};